module.exports = __webpack_public_path__ + "static/p09_pararoLvolandoAlaL-785236d64ea9d6edf1af475812cb6c7a.png";